import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { PrivateRouteHooks } from "./hooksPrivateRoute.js";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.isLogin.isLogin);

  useEffect(() => {
    if (!isAuthenticated) {
      localStorage.clear();
    }
  }, [isAuthenticated]);

  PrivateRouteHooks(rest.location.pathname);

  return (
    <Route
      {...rest}
      render={(props) => {
        return !isAuthenticated ? (
          <Redirect to={{ pathname: "/login" }} />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default PrivateRoute;
